import { Container, Typography } from "@material-ui/core"
import styled from "styled-components"
import { salesItems, serviceItems } from "./contactItems"
import ContactLink from "./ContactLink"

const StyledContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  padding: 40px 0;
  gap: 24px;

  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 60px 0;
    margin-top: 60px;
    border-top: 1px solid ${({ theme }) => theme.colors.borderGrey};
    gap: 40px;
  }
`
const StyledTypography = styled(Typography)`
  font-size: 28px;
  text-align: right;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
  }
`

const StyledSectionWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    flex-direction: row;
    gap: 32px;
  }
`
const StyledLinksWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 24px 12px;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme.colors.borderGrey};
    gap: 32px;
    flex-grow: 1;
  }
`
const StyledLinksTitle = styled(Typography)`
  font-size: 24px;
  text-align: right;
  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: center;
  }
`
const StyledLinksContainer = styled.div`
  padding: 8px 0;
  border-radius: 10px;
  border: 1px solid #d5d5d5;
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding: 0;
    border: none;
    flex-direction: row;
    justify-content: space-evenly;
  }
`

const ContactLinks = () => {
  return (
    <StyledContainer>
      <StyledTypography variant="h2">אנחנו כאן בשבילך</StyledTypography>
      <StyledSectionWrap>
        <StyledLinksWrapper>
          <StyledLinksTitle variant="h3">שירות לקוחות</StyledLinksTitle>
          <StyledLinksContainer>
            {serviceItems.map((item, index) => (
              <ContactLink key={index} {...item} />
            ))}
          </StyledLinksContainer>
        </StyledLinksWrapper>
        <StyledLinksWrapper>
          <StyledLinksTitle variant="h3">ייעוץ ומכירות</StyledLinksTitle>
          <StyledLinksContainer>
            {salesItems.map((item, index) => (
              <ContactLink key={index} {...item} />
            ))}
          </StyledLinksContainer>
        </StyledLinksWrapper>
      </StyledSectionWrap>
    </StyledContainer>
  )
}

export default ContactLinks
